export default "__VITE_ASSET__Ckc4ivcv__"